'use client';

import { cookieKey } from '@/shared/consts/cookie-key';
import { ValueOf } from '@/shared/types';

type CookieKey = ValueOf<typeof cookieKey>;

const isServer = typeof window === 'undefined';

function getCookie(name: CookieKey): string | undefined {
  if (isServer) return;

  const matches = document.cookie.match(
    new RegExp(`(?:^|; )${name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1')}=([^;]*)`),
  );

  return matches ? decodeURIComponent(matches[1]) : undefined;
}

function setCookie(
  name: CookieKey,
  value: string,
  options: { [key: string]: number | string } = { path: '/' },
) {
  if (isServer) return;

  let updatedCookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

  Object.keys(options).forEach((key) => {
    updatedCookie += `; ${key}`;
    const optionValue = options[key];
    updatedCookie += `=${optionValue}`;
  });

  document.cookie = updatedCookie;
}

function deleteCookie(name: CookieKey): void {
  if (isServer) return;

  setCookie(name, '', {
    'max-age': -1,
  });
}

function deleteAllCookies(): void {
  if (isServer) return;

  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i += 1) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
    deleteCookie(name.trim() as CookieKey);
  }
}

export const cookieUtil = {
  get: getCookie,
  set: setCookie,
  delete: deleteCookie,
  deleteAll: deleteAllCookies,
};
